import userRoleSelector from 'root/src/client/logic/auth/selectors/userRoleSelector';
import { userGroups } from 'root/src/shared/constants/auth';
export const isCreatorSelector = (state) => {
    return userRoleSelector(state) === userGroups.creator;
};
